import OverallPerformance from '../overallPerformance';

export const OverallPerformanceSubBranch = () => {
  return <OverallPerformance subBranchDashboard={true} />;
};
